import { TaskListItem } from './task-list-item';

export class TaskListPage {
    public pageCount: number;
    public rowCount: number;
    public results: TaskListItem[];
}
